import React from 'react';

const FastShipping = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5552_33622)">
      <mask
        id="mask0_5552_33622"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path d="M24 0H0V24H24V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_5552_33622)">
        <path
          d="M9.05809 16.8672V17.5432C9.05809 19.0644 7.84119 20.2813 6.32006 20.2813C4.79893 20.2813 3.58203 19.0644 3.58203 17.5432V16.8672H9.05809Z"
          fill="#F3FCFF"
        />
        <path
          d="M6.32033 20.9576C4.42738 20.9576 2.90625 19.4365 2.90625 17.5435V16.1914H9.73442V17.5435C9.73442 19.4365 8.21329 20.9576 6.32033 20.9576ZM4.29217 17.5435C4.29217 18.6928 5.20484 19.6055 6.35414 19.6055C7.50343 19.6055 8.41611 18.6928 8.41611 17.5435H4.29217Z"
          fill="#004C80"
        />
        <path
          d="M21.5639 16.8672V17.5432C21.5639 19.0644 20.347 20.2813 18.8259 20.2813C17.3048 20.2813 16.0879 19.0644 16.0879 17.5432V16.8672H21.5639Z"
          fill="#F3FCFF"
        />
        <path
          d="M18.8262 20.9576C16.9332 20.9576 15.4121 19.4365 15.4121 17.5435V16.1914H22.2403V17.5435C22.2403 19.4365 20.7192 20.9576 18.8262 20.9576ZM16.7642 17.5435C16.7642 18.6928 17.6769 19.6055 18.8262 19.6055C19.9755 19.6055 20.8882 18.6928 20.8882 17.5435H16.7642Z"
          fill="#004C80"
        />
        <path
          d="M3.5796 4.39453H13.3486C13.7542 4.39453 14.0923 4.73256 14.0923 5.13819V13.5213H3.5796C3.17397 13.5213 2.83594 13.1833 2.83594 12.7776V5.13819C2.83594 4.73256 3.17397 4.39453 3.5796 4.39453Z"
          fill="white"
        />
        <path
          d="M13.3492 4.39508C13.7548 4.39508 14.0928 4.73311 14.0928 5.13874V13.5218H3.58015C3.17452 13.5218 2.83649 13.1838 2.83649 12.7782V5.13874C2.83649 4.73311 3.17452 4.39508 3.58015 4.39508H13.3492ZM13.3492 3.04297H3.58015C2.43085 3.04297 1.48438 3.98945 1.48438 5.13874V12.812C1.48438 13.9613 2.43085 14.9078 3.58015 14.9078H15.4449V5.13874C15.4449 3.98945 14.4985 3.04297 13.3492 3.04297Z"
          fill="#004C80"
        />
        <path
          d="M19.0297 7.84375C19.3677 7.84375 19.672 7.97896 19.9424 8.18178C19.9424 8.21558 22.7142 11.0212 22.7142 11.0212C22.9508 11.3254 23.0522 11.6297 23.0522 11.9677V16.2945C23.0522 17.0381 22.4438 17.6466 21.7001 17.6466H3.51422C2.77056 17.6466 2.16211 17.0381 2.16211 16.2945V15.5846C2.16211 14.8409 2.77056 14.2325 3.51422 14.2325H14.8044V9.19586C14.8044 8.4522 15.4128 7.84375 16.1565 7.84375H17.4072H19.0297Z"
          fill="#F3FCFF"
        />
        <path
          d="M23.2553 10.6139L20.4159 7.77447L20.3483 7.70686C19.8075 7.16602 18.9962 7.16602 18.9962 7.16602H15.7511C14.8384 7.16602 14.0948 8.1801 14.0948 9.19418V13.5547H3.5145C2.399 13.5547 1.48633 14.4674 1.48633 15.5829V16.2928C1.48633 17.4083 2.399 18.3209 3.5145 18.3209H21.768C22.8835 18.3209 23.7962 17.4083 23.7962 16.2928V11.966C23.7962 11.459 23.6272 10.9857 23.2553 10.6139ZM22.4441 16.2928C22.4441 16.6646 22.1398 16.9688 21.768 16.9688H3.5145C3.14267 16.9688 2.83844 16.6646 2.83844 16.2928V15.5829C2.83844 15.2111 3.14267 14.9069 3.5145 14.9069H15.4807V9.19418C15.4807 8.82235 15.7849 8.51813 16.1567 8.51813H19.03C19.199 8.51813 19.368 8.58573 19.4694 8.68714L22.2413 11.4928C22.3427 11.6618 22.4103 11.797 22.4103 11.966V16.2928H22.4441Z"
          fill="#004C80"
        />
        <path
          d="M16.3594 12.4402V10.0064C16.3594 9.73602 16.5622 9.5332 16.8326 9.5332H18.9622C19.0974 9.5332 19.1988 9.56701 19.3002 9.66841L21.3284 11.7304C21.4298 11.8318 21.4636 11.9332 21.4636 12.0684V12.4064C21.4636 12.6769 21.2608 12.8797 20.9904 12.8797H16.8664C16.596 12.8797 16.3932 12.6769 16.3932 12.4064L16.3594 12.4402Z"
          fill="#004C80"
        />
        <path
          d="M8.65188 10.9535H0.201172V9.6014H8.65188V10.9535ZM10.68 8.75633H2.22934V7.40421H10.68V8.75633ZM12.7082 6.55914H4.25751V5.20703H12.7082V6.55914Z"
          fill="#FF7C1F"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_5552_33622">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default FastShipping;
